import { CSSProperties, ReactNode } from 'react'
import Carousel from 'react-grid-carousel'

interface MultipleCarouselProps {
  items: any[]
  renderComponent: (params: any) => ReactNode
  mobileBreakpoint?: number
  customResponsive?: any
  showDots?: boolean
  customDot?: (params: any) => ReactNode
  className?: string
  containerStyle?: CSSProperties
}

export const MultipleCarousel = ({
  items,
  renderComponent,
  customResponsive,
  showDots = false,
  customDot,
  mobileBreakpoint = 680,
  containerStyle,
  className
}: MultipleCarouselProps) => {
  const responsive = [
    {
      breakpoint: 768,
      cols: 2,
      gap: 52
    },
    {
      breakpoint: 10000,
      cols: 3,
      gap: 60
    }
  ]

  return (
    <div className={`w-full relative ${className}`}>
      <Carousel
        responsiveLayout={customResponsive || responsive}
        mobileBreakpoint={mobileBreakpoint}
        loop={true}
        showDots={showDots}
        containerStyle={containerStyle}
        dot={customDot || null}
        dotColorActive="#ff9c00"
      >
        {items.map((el, i) => (
          <Carousel.Item key={i}>{renderComponent(el)}</Carousel.Item>
        ))}
      </Carousel>
    </div>
  )
}
